import React, { useState}  from 'react';
import { connect } from 'react-redux';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import { Card, CardContent} from '@material-ui/core';
import Divider  from '@material-ui/core/Divider';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { getService } from 'reducers/service';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),    
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const useStyles = makeStyles(() => ({ 
  title:{
    background:'#0051a0',
    color: '#fff',    
    minHeight:60,
    marginBottom:10,
    alignContent: 'center', 
    '& h6': {
        fontSize:20,
        fontWeight:400, 
        textAlign: 'left',       
      },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    textAlign: 'center',
    width: 480,
    minHeight: 150,
    padding:'0px',
  },
  card: {
    width: 480,
    height: 480,
    background: 'fff',
    '& img': {
      width: '100%',
    },
  },
  actions: {
    textAlign: 'center',    
    '& button': {
      background: '#0051a0',
      color: '#fff',
      paddingLeft: '3em',
      paddingRight: '3em',
      textTransform: 'uppercase',
      '&:hover': {
        background: '#021090',
      },
    },
  },
  footer: {
    padding: '16px',
    textAlign: 'center',
    top: 395,
    right: 150,
    position: 'absolute',    
  },
  action: {
    marginBottom: 10,
  },
  releaseRoot:{
    maxHeight:424,
    overflowY: 'auto',
  },
  releaseItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 10px',
    fontSize: 18,
  },
  versionInfo: {
    display: 'flex',
    gap: '80px',
    alignItems: 'center',
    fontSize:18,    
  },
}));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

function ReleaseNotesDialog(props) {
  const classes = useStyles();
  const [fileList, setFileList] = useState([]);

  React.useEffect(() => {
    const fetchReleaseNotes = async () => {
      const service = getService('release-notes'); 
      const data = await service.get('NOTES,SET'); 
      if (data && data.length > 0) setFileList(data);
    };
  
    fetchReleaseNotes();
  }, []);

  const formatDate = (mmddyyyy) => {
    const day = mmddyyyy.slice(2, 4);
    const month = mmddyyyy.slice(0, 2);
    const year = mmddyyyy.slice(4);
    return `${month}/${day}/${year}`;
  };

  const downloadFile = async (fileName) => {
    const service = getService('release-notes'); 
    const response = await service.get('NOTES', {query: { fileName }});
    
    if (response) {
      const fileBlob = new Blob([new Uint8Array(response.fileBuffer)], { type: response.mimeType });
      const url = window.URL.createObjectURL(fileBlob);
      window.open(url, '_blank');
    }
  };

  const parseFiles = (files) => {
    const map = new Map();

    files.forEach((file) => {
      const match = file.match(/^(NOTES|SET)_(\d+\.\d+\.\d+)_(\d{8})\.pdf$/i);
      if (!match) return;

      const [_, product, version, rawDate] = match;
      const existing = map.get(version);
      if (!existing || product.toUpperCase() === 'NOTES') {
        map.set(version, {
          product: product.toUpperCase(),
          version,
          date: formatDate(rawDate),
          name: file,
        });
      }
    });

    return [...map.values()].sort((a, b) => (a.version < b.version ? 1 : -1));     
  };

  const releases = parseFiles(fileList);


  return (
    <Dialog onClose={props.close} open={true}>  
      <DialogTitle id="customized-dialog-title" className={classes.title}>
        Application Release Notes - Settings
      </DialogTitle>
      
      <DialogContent className='p-0'>
      <Card className={classes.card}>
          <CardContent className='p-0'>
            <div className={classes.releaseRoot}>
                {releases.map((release, idx) => (
                <div key={release.name}>
                    <div className={classes.releaseItem}>
                        <div className={classes.versionInfo}>
                            Version {release.version}
                            <span>{release.date}</span>
                        </div>
                        <div className={classes.actions}>            
                            <Button variant="contained" size="medium"  onClick={() => downloadFile(release.name)}>
                                View
                            </Button>
                        </div>
                    </div>
                    <Divider />
                </div>              
                ))}
            </div>
            <div className={classes.footer}>
             <div className={classes.actions}>
                <Button  variant="contained" size="large" className="my-2" onClick={props.close}>
                  Close
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </DialogContent>
    </Dialog>
  );
}

export default connect()(ReleaseNotesDialog);